module.exports = "/_next/static/images/features-c2b58b7d26a92d10bf32907271367736.svg";